import * as actionTypes from './actionTypes';
export const setSowEntities = entities => ({
  type: actionTypes.SET_SOW_ENTITY_LIST,
  entities
})

export const setSavedSow = data => ({
  type: actionTypes.SET_SAVED_SOW,
  data
})

export const setSowAllProducts = data => ({
  type: actionTypes.SET_SOW_ALLPRODUCTS,
  data
})

export const setSowSelectedProduct = data => ({
  type: actionTypes.SET_SOW_PRODUCT,
  data
})

export const setSowTab = (tabName, data) => ({
  type: actionTypes.SET_TAB_STATUS,
  data,
  tabName
})

export const setSowTabIndex = (tabName, index) => ({
  type: actionTypes.SET_TAB_INDEX,
  index,
  tabName
})

export const resetSowEntities = () => (
  {
    type: actionTypes.RESET_SOW_ENTITIES
  }
)

export const setSowAgent = (data) => (
  {
    type: actionTypes.SET_SOW_AGENT,
    data
  }
)

export const setSowProductAllAccounts = (data) => (
  {
    type: actionTypes.SET_SOW_PRODUCT_ALL_ACCOUNTS,
    data
  }
)


// WEBPACK FOOTER //
// ./src/components/createASow/actions/actionCreator.js